export const getHasAddedToBag = (state) => state.bag.hasAddedToBag

export default getHasAddedToBag
